import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { DocResponse } from '../../../../server/response/responseSchema';
import Box from '../../../uikit/Box';
import Frame from '../../../uikit/Frame';
import { MarkdownViewer } from '../../common/editor/MarkdownViewer';
import { apiClient } from '../../../clientUtils/apiClient';
import { useMobxInstance } from '../../../clientUtils/mobxUtil';

class ViewStore {
    doc: DocResponse | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    async fetch() {
        const result = await apiClient.doc.public.getDocByKey.$query({
            docKey: 'open-source-license',
        });

        runInAction(() => {
            this.doc = result;
        });
    }
}

/**
 * 오픈소스 라이선스 페이지
 * - 오픈소스 라이선스는 아래 태스크로 실행하면 doc 에 업데이트 됨
 * - pnpm task --name=license
 */
const LicensePage = observer(() => {
    const viewStore = useMobxInstance(ViewStore);

    useEffect(() => {
        viewStore.fetch();
    }, []);

    return (
        <Frame>
            <Frame.Title title="오픈소스 라이선스" />
            <Box>
                <MarkdownViewer markdown={viewStore.doc?.content || ''} className="break-words" />
            </Box>
        </Frame>
    );
});

export default LicensePage;
